import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import React from 'react';
import i18n from 'i18n-js';
import { switchScreen } from '@/hooks/navigate';
import BasicButton from "@/components/basic/BasicButton";

export default function ModalRequestSent({ navigation, route }) {

    const { title, text, options, textPlain, back } = route.params

    console.log('BACK', back)

    return (
        <View className="flex-1 bg-[#00000050] justify-center">
            <VStack space='md' className="m-3 bg-secondary-50 px-4 py-5 rounded-[5px]">
                <Text className="font-[400] text-2xl leading-2xl text-secondary-900">{i18n.t(title)}</Text>
                <Text className="font-[400] text-xl leading-2xl text-secondary-900">{text ? i18n.t(text, options) : textPlain}</Text>
                <View className="pt-3 w-[100%]">
                    <BasicButton onPress={() => { back ? switchScreen(navigation, back) : switchScreen(navigation, 'BACK') }} text={i18n.t('addContact.ok')}/>
                </View>
            </VStack>
        </View>
    );
}
